import { defineAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const initialAbility = defineAbility((can) => {
    can('read', 'Auth')
  })

  nuxtApp.vueApp.use(abilitiesPlugin, initialAbility, {
    useGlobalProperties: true,
  })

  return {
    provide: {
      ability: initialAbility,
    },
  }
})
